import { en } from './en'
import { fr } from './fr'

export const resourcesPage = {
  en,
  fr
}